<template>
  <div class="dashboard-loading-wrapper">
    <el-card>
      <div class="img-loading">
          <vue-content-loading :width="320" :height="320" primary="#E6EBF5" secondary="#D8DCE5">
            <rect x="0" y="24" rx="4" ry="4" width="100%" height="100%"/>
          </vue-content-loading>
      </div>
      <div class="info-loading">
        <vue-content-loading :width="320" :height="120" primary="#E6EBF5" secondary="#D8DCE5" >
          <rect x="0" y="50" rx="0" ry="0" width="100%" height="100%"/>
          <!-- <rect x="0" y="40" rx="4" ry="4" width="75%" height="15"/> -->
          <!-- <rect x="250" y="70" rx="4" ry="4" width="70" height="40"/> -->
        </vue-content-loading>
      </div>
    </el-card>
  </div>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  data() {
    return {
    };
  },
  components: {
    VueContentLoading,
  },
};
</script>

<style lang="scss">
.dashboard-loading-wrapper {
  height: 100%;
  .el-card {
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 222px;
    width: 100%;
    height: 100%;
    .el-card__body {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      width: calc(100% - 40px);
      height: calc(100% - 40px);
      .img-loading {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 320px;
        height: 320px;
        max-width: 100%;
        max-height: 100%
      }
      .info-loading {
        width: 160px;
        height: 80px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// DashboardItemLoading.vue?4ee4414e